import React, { useContext } from 'react'
import "./Notfound.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
import { LanguageContext } from '../Language/LanguageContext'
import { Container } from '../Library'

function NotFound() {
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.error

    return (
        <Container id="not-found" topbarTitle={lang.page_not_found}>
            <FontAwesomeIcon icon={faQuestionCircle} className="icon"/>
            <div className="title">{lang.page_not_found}</div>
            <div className="desc">{lang.page_notfound_desc}</div>
        </Container>
    )
}

export default NotFound
